import { BtnStyling } from '@/components/Button';
import {
  ChartOfAccountsTypeEnum,
  ClientTaxDetailsStatusEnum,
  DataCorrectionStatusEnum,
  DataUnitBlockedActionEnum,
  DatevFileStandardEnum,
  DatevOptionsEnum,
  ReportResultErrorCodeEnum,
  DUItemStatusEnum,
  EvaluatiionStatusEnum,
  InvoiceDocumentCorrectionStatusEnum,
  InvoiceDocumentErrorSeverityEnum,
  JTLCredentialsStatusEnum,
  ManualUploadFilesWorkStatusEnum,
  MODAL_MODE,
  PricingModelEnum,
  ProformaInvoiceStatusEnum,
  RolesEnum,
  SellerFilingReportStatusEnum,
} from './enums';
import { WorkFlowTaskType } from '@/components/ClientWorkflow/ClientWorkflowTodo';
import { TaskForEnum } from '@/components/OpenTasks/OpenTasks.helpers';
import { CES_CONFIG } from '@/components/CESSurveyPopup/CESSurvey.helpers';
export interface IRoute {
  path: string;
  component?: React.ComponentType<any>;
  exact?: boolean;
  redirectTo?: string;
  title?: string;
}

export interface SelectOption {
  id: string | number;
  name: string;
  content?: JSX.Element;
}

export enum UserFlagEnum {
  'fba' = 'fba',
  'oss_self_service' = 'oss_self_service',
}

export interface RegisterInput {
  phone?: string;
  email: string;
  name: string;
  family_name: string;
  country: string;
  company_name: string;
  password: string;
  language: 'de' | 'en';
  role: RolesEnum;
  newsletter_agreement: boolean;
  tos_accepted: boolean;
  tos_version: string;
  data_protection_accepted: boolean;
  data_protection_version: string;
  flag?: UserFlagEnum;
  sharing_data_with_jtl_group_accepted: boolean;
}
export interface RegisterUserInput {
  email: string;
  name: string;
  family_name: string;
  password: string;
  language: 'de' | 'en';
  newsletter_agreement: boolean;
  tos_accepted: boolean;
  tos_version: string;
  data_protection_accepted: boolean;
  data_protection_version: string;
  client_uuid: string;
  role: RolesEnum;
  sharing_data_with_jtl_group_accepted: boolean;
}
export interface RegisterTaxAdvisorInput extends RegisterUserInput {
  phone: string;
  invitation_id: string;
}

export type Lang = 'en' | 'de';

export interface ClientWarehouseBE {
  country: string;
  active_from: string;
  count_of_sold_items: number;
}
export interface ClientWarehouse {
  country: string;
  active_from: Date;
  count_of_sold_items: number;
}

export interface CountryThreshold {
  country: string;
  threshold: { value: number; currency: string };
}

export interface AmazonConnectCredentialsModel {
  seller_id: string;
}
export type AmazonDataImportStatus = 'in-process' | 'loaded' | 'not-started';
export interface AmazonDataImportStatusModel {
  processed: number;
  status: AmazonDataImportStatus;
  total: number;
}

export interface BaseResponseError {
  msg: string;
  msg_type: string;
}
export interface ValidationResponseError extends BaseResponseError {
  errors: {
    [key: string]: string;
  };
}

export interface Country {
  id: number;
  name: string;
  short_name: string;
  is_eu?: boolean;
}
export interface PublicClient {
  company_id: string;
  country: any;
  name: string;
}

export interface PostAmazonConnectInput {
  client_uuid: string;
  seller_id: string;
  oauth_code: string;
}

export interface PostClientAmazonConnectInput {
  seller_id: string;
  oauth_code: string;
  company_id?: string;
}

export type QuestionType =
  | 'use_oss'
  | 'have_vat_ids'
  | 'vat_ids'
  | 'mu_feedback';

export interface ClientFeedback {
  positive: number | null;
  page: string;
  comment: string;
}
export interface Answer {
  answer: boolean | string;
}

export interface AmazonIntegration {
  has_api_refresh_token: boolean;
  has_mws_auth_token: boolean;
  name: string;
  seller_id: string;
  api_refresh_token_date?: string;
  invalid: boolean;
  disabled_at: string | null;
  is_disabled: boolean;
}

export interface VATId {
  Country: {
    id: number;
    name: string;
    short_name: string;
  };
  payment_frequency?: string;
  status: ClientTaxDetailsStatusEnum;
  vat_number: string;
  start_date_vat_number: string;
  tax_number: string;
  start_date_tax_number: string;
  status_updated_date?: string;
  tax_number_status?: number;
  vat_number_status?: number;
  registration_date?: string;
  filing_period_from: string;
  filing_period_to?: string;
  report_settings: ReportSettings[];
}

export interface Amount {
  amount: number;
  currency: string;
}

export interface Payment {
  Amounts: Amount[];
  Country: {
    id: number;
    name: string;
    short_name: string;
  };
  due_date: string;
  type: 'local' | 'oss';
  original_currency: string;
  payment_instruction_id: number;
}

export interface Report {
  country: { id: number; short_name: string; name: string };
  deadline_date: string;
  type: string;
  period: ReportPeriod;
  report_sub_type: ReportSubType;
}

export interface VATFilingCalendarReport extends Report {
  id: number;
  confirmation: FilingReportConfirmation;
  status: SellerFilingReportStatusEnum;
}

export interface FCTransfer {
  arrival_country: string;
  departure_country: string;
  number: number;
}
export interface CrossedOss {
  crossed_oss_threshold_label: string;
}

export interface UploadedFile {
  id: number;
  name: string;
  path: string;
  status: number;
  work_status: ManualUploadFilesWorkStatusEnum;
  imported_at: string;
  period_from: string;
  period_to: string;
  bucket: string;
  fresh?: boolean;
  errors: string[];
  source: Source;
  uploaded_by_client: boolean;
  errors_message?: ErrorsMessage;
  documents_with_error_number: number;
  update_progress?: UploadedDocumentUpdateProgress;
  documents_in_turnover_number: number;
  uploaded_rows_number?: number;
}

export interface CorrectionErrorsMessage {
  message: string;
}
export interface UploadedCorrectionFile {
  id: number;
  bucket: string;
  imported_at: string;
  is_valid: boolean;
  name: string;
  num_transactions: number;
  path: string;
  uploaded_by_client: boolean;
  validation_errors: CorrectionErrorsMessage[];
}

export interface UploadedDocumentUpdateProgress {
  id: number;
  progress: number;
  total: number;
  type:
    | 'refresh-defined-fields'
    | 'remove-data'
    | 'bulk-update'
    | 'reload-data'
    | 'push-into-turnover'
    | 'upload-data'
    | 'recalculate-totals';
  field?: string;
}
export interface ErrorsMessage {
  id: number;
  language: Lang;
  created_at: string;
  filename: string;
  bucket: string;
  message: string;
}

export enum CurrentReporterEnum {
  we = 'we',
  other = 'other',
  ossSelfService = 'oss_self_service',
}

export interface Clerk {
  Id: number;
  FullName: string;
  HubspotMeetingLink?: string;
}

export interface ClientDatevDetails {
  service_from?: string;
  service_to?: string;
  display_since?: string;
  chat_of_account_type?: ChartOfAccountsTypeEnum;
  consultant_number?: number;
  client_number?: number;
  accounts_length?: number;
  accounts_length_credit?: number;
  fiscal_year_start?: string;
  use_booking_key_40?: boolean;
  chart_of_account_accepted_at?: string;
  activate_expenses?: boolean;
  extf_belegfeld1_use_order_id?: boolean;
  use_booking_key_401?: boolean;
}

export interface UserCompany {
  company_id: string;
  name: string;
  Country?: Country;
  ProformaExportNeeded?: boolean;
  DATEVExportNeeded: boolean;
  EasybillClient: boolean;
  ErpName: string;
  Clerk?: Clerk;
  ClientOSSDetails?: {
    RegistrationDate?: string;
    RegistrationCountry?: string;
    CurrentReporter?: CurrentReporterEnum;
    VATIdNumber?: string;
    FilingPeriodFrom?: string;
    FilingPeriodTo?: string;
    OssEffectiveStartDate?: string;
    SubmissionBy?: string;
  };
  ClientDatevDetails?: ClientDatevDetails;
  PaymentOverdue: boolean;
  IsUseNewProcess: boolean;
  PricingModel?: PricingModelEnum;
  ProformaSourceStartDate?: string;
  OnboardingToDo: boolean;
  StripeClient: boolean;
  HasIntrastatDetails?: boolean;
}

export type PeriodType = 'month' | 'quarter' | 'year';

export interface ReportPeriod {
  id: number;
  type: PeriodType;
  from_date: string;
  to_date: string;
  label: string;
}

export interface Recepient {
  id: number;
  name: string;
  email: string;
}

export interface ReportConfirmationTemplate {
  recipients: Recepient[];
  period: ReportPeriod;
  country: Country;
}
export interface ReportConfirmation extends ReportConfirmationTemplate {
  files: string[];
  id: number;
  sent_at?: string;
  comment: string;
}

export interface PaymentInstructionTemplate {
  Country: {
    short_name: string;
    name: string;
  };
  payee: string;
  credit_institution: string;
  iban: string;
  bic: string;
  period: ReportPeriod;
  recipients: Recepient[];
  currency: string;
  purpose?: string;
  due_date?: string | null;
  is_sepa: boolean;
  summary_included?: boolean;
  is_null_report: boolean;
  comment?: string;
}

export interface ReportConfirmationFile {
  id: number;
  filename: string;
}

export interface PaymentConfirmationDocument {
  id: number;
  filename: string;
  bucket: string;
  externalUserUuid?: string;
  importedBy?: Clerk;
  path: string;
  created_at?: string;
}

export interface PaymentConfirmation {
  id: number;
  created: Date;
  externalUserUuid?: string;
  documents: PaymentConfirmationDocument[];
}

export interface PaymentInstruction
  extends Omit<PaymentInstructionTemplate, 'currency'> {
  id: number;
  purpose: string;
  due_date: string;
  amount: {
    currency: string;
    amount: number;
  };
  created_at: string;
  sent_at?: string;
  file?: string;
  confirmed?: boolean;
  confirmed_at?: string;
  payment_confirmation?: PaymentConfirmation;
  cancelled?: boolean;
  cancelled_at?: string;
}

export type SellerFilingReportType = 'oss' | 'local' | 'intrastat';

export interface SellerFilingReportFile {
  created_at: string;
  id: number;
  name: string;
  option: string;
  status: string;
}

export interface FilingReportConfirmation {
  comment: string;
  documents: ReportConfirmationFile[];
  id: number;
  sent_at: string;
}

export interface SellerFilingReport {
  confirmation: FilingReportConfirmation;
  country: Country;
  deadline_date: string;
  submitted_at?: string;
  id: number;
  payment_instruction?: PaymentInstruction;
  type: SellerFilingReportType;
  period: ReportPeriod;
  agenda_confirmed?: boolean;
  status: SellerFilingReportStatusEnum;
  files: SellerFilingReportFile[];
  fiscal_rep_required: boolean;
  correction_type?: string;
  report_sub_type: ReportSubType;
  inaccuracy_reason: string;
  is_null_report?: boolean;
}

export interface NormalizedSellerFilingReport extends SellerFilingReport {
  completed_filing: boolean;
}

export interface EasybillData {
  create_date: string;
  invalid_date: string;
  is_valid: boolean;
}

export interface BillbeeData {
  connected_at: string;
  invalid_at: string;
  is_active: boolean;
  is_valid: boolean;
}

export type TransactionType = 'REGULAR' | 'UNION-OSS';

export interface DatevTransaction {
  account: number;
  additional_content: string;
  additional_type: string;
  booking_text: string;
  cost1: string;
  cost2: string;
  counter_account: number;
  date: string;
  entry_type: number;
  external_document_nr: string;
  invoice_nr1: string;
  invoice_nr2: string;
  manual_skonto_in_dm: number;
  manual_skonto_in_euro: number;
  manual_skonto_in_fw: number;
  percent: number;
  revenue_in_dm: number;
  revenue_in_euro: number;
  skonto_in_dm: number;
  skonto_in_euro: number;
  tax_code: number;
  vat_id: string;
}
export interface DatevTransactionASCII {
  beleg_1: string;
  beleg_2: string;
  bu_schluessel?: string;
  buchungstext: string;
  datum: string;
  eu_land_ust_id_bestimmung?: string;
  eu_land_ust_id_ursprung?: string;
  eu_steuersatz_bestimmung?: string;
  eu_steuersatz_ursprung?: string;
  fremdbelegnr: string;
  gegenkonto: number;
  konto: number;
  kost_1: string;
  kost_2: string;
  steuersatz: string;
  umsatz_in_eur: number;
  umsatzsteuer_id: string;
  zusatzart: string;
  zusatzinhalt: string;
}
export interface DatevTransactionEXTF {
  abrechnungsreferenz: string;
  abw_skontokonto: string;
  abw_versteuerungsart: string;
  auftragsnummer: string;
  basis_umsatz: string;
  belegdatum: string;
  belegfeld_1: string;
  belegfeld_2: string;
  beleginfo_art_1: string;
  beleginfo_art_2: string;
  beleginfo_art_3: string;
  beleginfo_art_4: string;
  beleginfo_art_5: string;
  beleginfo_art_6: string;
  beleginfo_art_7: string;
  beleginfo_art_8: string;
  beleginfo_inhalt_1: string;
  beleginfo_inhalt_2: string;
  beleginfo_inhalt_3: string;
  beleginfo_inhalt_4: string;
  beleginfo_inhalt_5: string;
  beleginfo_inhalt_6: string;
  beleginfo_inhalt_7: string;
  beleginfo_inhalt_8: string;
  beleglink: string;
  beteiligtennummer: string;
  bezeichnung_so_bil_sachverhalt: string;
  bu_49_funktionsergaenzung: string;
  bu_49_hauptfunktionsnummer: string;
  bu_49_hauptfunktionstyp: string;
  bu_schluessel?: string;
  buchungs_guid: string;
  buchungstext: string;
  buchungstyp: string;
  bvv_position: string;
  datum_zuord_steuerperiode: string;
  diverse_adressnummer: string;
  erloeskonto_anzahlungen: string;
  eu_land_anzahlungen: string;
  eu_land_ust_id_bestimmung?: string;
  eu_land_ust_id_ursprung?: string;
  eu_steuersatz_anzahlungen: string;
  eu_steuersatz_bestimmung?: string;
  eu_steuersatz_ursprung?: string;
  faelligkeit: string;
  festschreibung: string;
  forderungsart: string;
  funktionsergaenzung_ll: string;
  gegenkonto_ohne_bu_schluessel: number;
  generalumkehr_gu: string;
  geschaeftspartnerbank: string;
  gesellschaftername: string;
  gewicht: string;
  herkunft_kz: string;
  identifikationsnummer: string;
  kennzeichen_so_bil_buchung: string;
  konto: number;
  kost_1_kostenstelle: string;
  kost_2_kostenstelle: string;
  kost_datum: string;
  kost_menge: string;
  kurs: string;
  land: string;
  leistungsdatum: string;
  postensperre: string;
  postensperre_bis: string;
  sachverhalt: string;
  sachverhalt_ll: string;
  sachverhalt_llanzahlungen: string;
  sepa_mandatsreferenz: string;
  skonto: string;
  skontosperre: string;
  skontotyp: string;
  soll_haben_kennzeichen: string;
  steuersatz: string;
  stueck: string;
  umsatz_ohne_soll_haben_kz: number;
  ust_schluessel_anzahlungen: string;
  veranlagungsjahr: string;
  wkz_basis_umsatz: string;
  wkz_umsatz: string;
  zahlweise: string;
  zeichnernummer: string;
  zinssperre: string;
  zugeordnete_faelligkeit: string;
  zusatzinformation_art_1: string;
  zusatzinformation_art_2: string;
  zusatzinformation_art_3: string;
  zusatzinformation_art_4: string;
  zusatzinformation_art_5: string;
  zusatzinformation_art_6: string;
  zusatzinformation_art_7: string;
  zusatzinformation_art_8: string;
  zusatzinformation_art_9: string;
  zusatzinformation_art_10: string;
  zusatzinformation_art_11: string;
  zusatzinformation_art_12: string;
  zusatzinformation_art_13: string;
  zusatzinformation_art_14: string;
  zusatzinformation_art_15: string;
  zusatzinformation_art_16: string;
  zusatzinformation_art_17: string;
  zusatzinformation_art_18: string;
  zusatzinformation_art_19: string;
  zusatzinformation_art_20: string;
  zusatzinformation_inhalt_1: string;
  zusatzinformation_inhalt_2: string;
  zusatzinformation_inhalt_3: string;
  zusatzinformation_inhalt_4: string;
  zusatzinformation_inhalt_5: string;
  zusatzinformation_inhalt_6: string;
  zusatzinformation_inhalt_7: string;
  zusatzinformation_inhalt_8: string;
  zusatzinformation_inhalt_9: string;
  zusatzinformation_inhalt_10: string;
  zusatzinformation_inhalt_11: string;
  zusatzinformation_inhalt_12: string;
  zusatzinformation_inhalt_13: string;
  zusatzinformation_inhalt_14: string;
  zusatzinformation_inhalt_15: string;
  zusatzinformation_inhalt_16: string;
  zusatzinformation_inhalt_17: string;
  zusatzinformation_inhalt_18: string;
  zusatzinformation_inhalt_19: string;
  zusatzinformation_inhalt_20: string;
}

export interface Paging {
  page: number;
  page_size: number;
  total_pages: number;
  total_rows: number;
}

export interface ProformaInvoiceItemsPaging extends Paging {
  total_rows_without_pp?: number;
}

export type DatevAggregatedItem = {
  entry_type: number;
  count: number;
  year: number;
  month: number;
};

export interface PostTypeformSubmissionInput {
  response_id: string;
  form_id: string;
  feature_flag: string;
}

export interface TypeformSubmission extends PostTypeformSubmissionInput {
  user_id: number;
  created_at: string;
}

export type FilingFrequencyType = 'monthly' | 'quarterly' | 'yearly';
export type PaymentFrequencyType = 'monthly' | 'quarterly';

export interface InvoiceBookResponse {
  paging: PagingInfo;
  data: TurnoverItem[];
}
export interface InvoiceDocumentsResponse {
  paging: PagingInfo;
  data: InvoiceDocument[];
}

export interface TurnoverItem {
  is_oss: boolean;
  channel_id: number;
  invoice_type: string;
  channel_name: string;
  foreign_transaction_number: string;
  invoice_number: string;
  document_date: string;
  arrival_state?: string;
  arrival_street?: string;
  arrival_postal_code?: string;
  departure_postal_code?: string;
  departure_city?: string;
  b2b_buyer_name?: string;
  b2b_buyer_vat_number?: string;
  vat_currency: string;
  arrival_country_id: number;
  departure_country_id: number;
  vat_country_id: number;
  arrival_city?: string;
  is_plausible: boolean;
  turnover_id: number;
  invoice_vat_rate: number;
  invoice_total_net_amount_for_vat_rate: number;
  invoice_total_brutto_amount?: number;
  invoice_total_vat_amount?: number;
  invoice_total_net_amount_eur?: number;
  invoice_total_brutto_amount_eur?: number;
  invoice_total_vat_amount_eur?: number;
  invoice_total_net_amount?: number;
}

export interface PagingInfo {
  page: number;
  page_size: number;
  total_pages: number;
  total_rows: number;
  total_oss_rows: number;
  total_vat_amount: number;
  total_brutto_amount: number;
  total_net_amount: number;
}

export interface AgrregatedDataType {
  country: { id: number; short_name: string; name: string };
  date: string;
  transactions_number: number;
  gross_amount: number;
  vat_amount: number;
}

export type Source =
  | 'amazon'
  | 'easybill'
  | 'incoming_invoices'
  | 'manual'
  | 'billbee'
  | 'jtl'
  | 'shipment'
  | 'proforma_non_amazon';

export interface DUSourceItem {
  id: number;
  source_type: Source;
  files: UploadedFile[];
  type: string;
  status: DUItemStatusEnum;
  no_data_needed: boolean;
}

export interface DataUnit {
  id: number;
  date: string;
  items: DUSourceItem[];
  confirmed_by?: string;
  confirmation_date?: string;
  correction_status: DataCorrectionStatusEnum;
  data_modified_date?: string;
  allow_corrections_date?: string;
  deadline_date: string;
  is_confirmation_blocked_until_fifth?: boolean;
  confirmation_blocked_hint?: { en: string; de: string } | null;
  blocked_actions?: DataUnitBlockedActionEnum[];
}

type MessageParametersMap = {
  VAT_RATE_ERROR_DOESNT_MATCH_VAT_COUNTRY: {
    vat_rate: number;
    vat_rates: number[];
    vat_country: string;
  };
  BIG_MISMATCH_INVALID_BRUTTO_AMOUNT_FOR_VAT_RATE: {
    netto: number;
    brutto: number;
    vat_rate: number;
  };
  BIG_MISMATCH_INVALID_VAT_AMOUNT_FOR_VAT_RATE: {
    netto: number;
    vat_rate: number;
    vat_amount: number;
  };
  CROSS_BORDER_B2B_VAT_RATE_NEITHER_ZERO_NOR_DEPARTURE: {
    vat_rates: number[];
    departure_country: string;
  };
  EU_TO_UK_ZERO_VAT_RATE_THRESHOLD_PASSED_IMPORT_TAX_RESPONSIBLE_SELLER: {
    vat_rates: number[];
  };
  SHOULD_BE_OSS_BUT_VAT_RATE_DEPARTURE: {
    vat_rates: number[];
  };
  UK_VAT_RATE_ZERO_THRESHOLD_PASSED_IMPORT_TAX_RESP_IS_EMPTY: {
    vat_rates: number[];
  };
};

export type InvoiceDocumentError =
  | {
      [K in keyof MessageParametersMap]: {
        severity: InvoiceDocumentErrorSeverityEnum;
        code: K;
        message_parameters: MessageParametersMap[K];
      };
    }[keyof MessageParametersMap]
  | {
      severity: InvoiceDocumentErrorSeverityEnum;
      code: string;
      message_parameters: Record<string, unknown>;
    };

export interface InvoiceDocument {
  id: number;
  type?: string;
  source_type?: Source;
  invoice_number?: string;
  document_date?: string;
  currency?: string;
  departure_country?: string | Country;
  departure_postal_code?: string;
  vat_country?: Country;
  is_oss?: boolean;
  arrival_country?: string | Country;
  arrival_postal_code?: string;
  vat_rate?: number;
  net_amount?: number;
  brutto_amount?: number;
  vat_amount?: number;
  b2b_buyer_vat_number?: string;
  channel?: string;
  errors: InvoiceDocumentError[];
  turnover_id?: number;
  muted?: boolean;
  foreign_transaction_number?: string;
  ref_invoice_id?: number;
  ref_invoice_date?: string;
  updates: InvoiceDocumentUpdates[] | null;
  correction_status: InvoiceDocumentCorrectionStatusEnum;
}

export interface InvoiceDocumentUpdates {
  id: number;
  document_id: number;
  field_name: keyof InvoiceDocument;
  previous_value: string;
  created_at: string;
}

export interface InvoiceDocumentUpdateProgress {
  id: number;
  progress: number;
  total: number;
  type:
    | 'refresh-defined-fields'
    | 'remove-data'
    | 'bulk-update'
    | 'reload-data'
    | 'push-into-turnover'
    | 'upload-data'
    | 'recalculate-totals';
  field?: keyof InvoiceDocument;
}

export interface InvoicesData {
  items: InvoiceDocument[];
  limit: number;
  page: number;
  total: number;
  filtered_total: number;
  errors: string[];
  plausible_errors: string[];
  rules: string[];
  documents_in_turnover: number;
}

export enum PeriodTypeEnum {
  month = 'month',
  quarter = 'quarter',
}

export interface GetEvaluationInput {
  start_date: string;
  end_date: string;
}
export interface PostEvaluationInput extends GetEvaluationInput {
  external_user_uuid: string;
}

export interface Evaluation {
  id: number;
  requestedAt: Date;
  period: string;
  status: EvaluatiionStatusEnum;
  file: string;
  vatCountry: string;
  externalUserUuid?: string;
  company_id: string;
  // createdAt: Date;
  // generationStartedAt: Date;
  // numRows: number;
  // numHealthCheckProblems: number;
  // departureCountry: string;
  // arrivalCountry: string;
  // errorMessage: string;
}

export interface NormalizedEvaluation extends Evaluation {
  startDate: Date;
  endDate: Date;
  type: 'month' | 'quarter' | 'year';
}

export interface ProformaInvoice {
  seller_account_id: string;
  non_amazon?: boolean;
  vat_report_id?: number;
  invoice_number: string;
  document_date: string;
  arrival_country: Country;
  departure_country: Country;
  arrival_postal_code?: string;
  departure_postal_code?: string;
  total_net_amount: number;
  total_net_amount_eur?: number;
  total_brutto_amount: number;
  total_brutto_amount_eur?: number;
  total_vat_amount: number;
  total_vat_amount_eur?: number;
  currency: string;
  vat_rate: number;
  id: number;
  is_draft?: boolean;
  seller_vat_number?: string;
  buyer_vat_number?: string;
  status: ProformaInvoiceStatusEnum;
}

export interface DataUnitStatsItem {
  data_unit_id: number;
  documents_count: number;
  errors_count: number;
  warnings_count: number;
  notices_count?: number;
  date: string;
  errors: ErrorDescriptionType[];
  warnings: ErrorDescriptionType[];
  notices?: ErrorDescriptionType[];
  muted_count?: number;
  to_be_corrected_count?: number;
  corrected_count?: number;
  blocked_count?: number;
}

export interface ErrorDescriptionType {
  code: string;
  count: number;
}

export interface JTLCredentials {
  username: string;
  status: JTLCredentialsStatusEnum;
  filing_from?: string;
}

export interface CreateJTLCredentialsDTO extends JTLCredentials {
  password: string;
}

export type JTLConnectorType = 't4dt' | 'jera' | 'countx';

export interface ConnectorInfoResponse {
  type: JTLConnectorType | string;
  connector_version: string;
  wawi_version: string;
  is_online: boolean | null;
  machine_name: string;
  // Verified against the jtl-api writer (calculateJtlSourceStatus) and real DB
  // (JTL-471): the current writer emits active/future/passed/null; legacy,
  // un-backfilled rows still carry the 'no_data_source' literal.
  jtl_source_status: 'active' | 'future' | 'passed' | 'no_data_source' | null;
}

export interface InvoiceDocumentSuggestionsType {
  error_code: number;
  code: number;
  name: string;
}

export interface ResolveOptionsDataType extends InvoiceDocumentSuggestionsType {
  title: string;
  description: string;
}

export interface ComplianceDocumentErrorsType {
  class: string;
  code: number;
  error_name: string;
  suggestions: { code: number; name: string }[];
  type: string;
  client_description: {
    en: string;
    de: string;
  };
}

export type PlaceToUpload = 'main' | 'todo';

export interface Channel {
  id: number;
  name: string;
  account_number: string;
}

export interface ChannelAccountNumber {
  id: number;
  account_number: number;
  channel: Channel;
}

export interface DefaultAccountMarketplaceNumber {
  account_number: number;
  marketplace: Marketplace;
  id: number;
}
export interface AccountMarketplaceNumber {
  account_number: number;
  marketplace: Marketplace;
  id: number;
  external_user_uuid?: string;
}
export interface ClientAccountMarketplaceNumber {
  id: number;
  account_number: number;
  marketplace: Marketplace;
  account_type: AccountType;
  external_user_uuid?: string;
}

export interface PostClientChannelAccountItem {
  id: number;
  account_number: number;
  channel: number;
}

export type ReportSubType = keyof typeof REPORTS_SUB_TYPES;
export const REPORTS_SUB_TYPES = {
  ic_sale: 'IC-sales',
  vat_report: 'VAT-report',
  intrastat_in: 'Intrastat Arrival',
  intrastat_out: 'Intrastat Dispatch',
};

export interface DefaultAccountNumber {
  account_number: number;
  country?: Country;
}
export interface AccountNumber extends DefaultAccountNumber {
  id: number;
  account_type: AccountType;
}

export interface AccountType {
  id: number;
  account_type: string;
  account_numbers?: DefaultAccountNumber[];
  account_marketplace_numbers?: DefaultAccountMarketplaceNumber[];
}

export interface PostAccountNumbersInputItem {
  id?: number;
  account_number: number;
  country?: number;
  account_type: number;
}
export interface PostClientAccountMarketplaceNumberInput {
  id?: number;
  account_number: number;
  marketplace?: number;
  account_type: number;
  external_user_uuid?: string;
}

export interface DefaultAccWithType
  extends Omit<DefaultAccountNumber, 'account_number'> {
  account_type: string;
  account_number: string;
}

export interface CountryRowDefaultValues {
  vat_rate_high: string;
  vat_rate_middle: string;
  vat_rate_low: string;
  vat_rate_low_second: string;
  b2b_buyer_vat_number_not_null: string;
  arrival_country_not_EU: string;
  commingling_buy_taxable: string;
  commingling_buy_tax_exempt: string;
}

export interface DatevFile {
  created_at: string;
  file: string;
  id: number;
  option: DatevOptionsEnum;
  service_date: string;
  status: number;
  standard: DatevFileStandardEnum;
  error_message?: string;
  error_code?: ReportResultErrorCodeEnum;
  metadata?: {
    missing_tax_details?: {
      client_id: number;
      client_name: string;
      country: string;
      error: string;
    }[];
  };
}

export interface VatRate {
  country: Country;
  vat_rate_option: {
    option_value: string;
  };
  vat_rate: string;
  effective_from: string;
  effective_till: string;
}

export interface Invitation {
  accepted_at?: string;
  canceled_at?: string;
  company_id: string;
  created_at: string;
  creator_user_id: number;
  email: string;
  expired_at: string;
  hash: string;
  id: number;
  invited_user_id?: number;
  parent_invitation_id?: number;
  sent_at?: string;
  failed_at?: string;
}

export interface InvitationWithCompanyName extends Invitation {
  company_name: string;
}
export interface CompanyUser {
  Email: string;
  FamilyName: string;
  Id: string;
  Name: string;
  Role: RolesEnum;
}

export interface FeedbackModalOption {
  value: string;
  label: string;
}

export const DEADLINE_TYPES = {
  normal: 'Next month (Standard)',
  delayed: 'After month (Delayed)',
};

export type DeadlineType = keyof typeof DEADLINE_TYPES;
export interface ReportSettings {
  id?: number;
  deadline_type: DeadlineType;
  frequency: FilingFrequencyType;
  report_sub_type: ReportSubType;
}

export type DatevTransactionsColumnsFilterType =
  | 'Focus'
  | 'Extended'
  | 'Technical';

export interface ProformaInvoiceItem {
  id: number;
  proforma_invoice_id: number;
  item_description: string;
  sku: string;
  asin: string;
  transaction_type: string;
  quantity: number;
  single_net_price: number;
  single_net_price_euro: number;
  total_net: number;
  total_net_euro: number;
}

export interface DataUnitsErrors {
  errors: [
    {
      code: number;
      name: string;
    },
  ];
  notices: [
    {
      code: number;
      name: string;
    },
  ];
  warnings: [
    {
      code: number;
      name: string;
    },
  ];
}

export interface CountryTotal {
  id: number;
  country: string;
  netto: number;
  vat_amount: number;
  brutto: number;
  excluded_netto: number;
  excluded_vat_amount: number;
  excluded_brutto: number;
  is_oss: boolean;
  type: string;
  data_unit_id: number;
  data_unit_item_id: number;
}

export interface InputVatTotal {
  data_unit_id: number;
  data_unit_item_id: number;
  netto: number;
  vat_amount: number;
  brutto: number;
  documents_count: number;
}

export interface NormalizedCountryTotal extends CountryTotal {
  data_source?: Source;
}

export interface DUItemTotals {
  data_unit_item_id: number;
  corrected: number;
  documents: number;
  errors: number;
  in_turnover: number;
  notices: number;
  to_be_corrected: number;
  warnings: number;
  data_source: Source | undefined;
  country_total?: CountryTotal[]; //TODO remove optional after de-mocking
}

export interface DataUnitTotals {
  corrected: number;
  data_unit_id: number;
  documents: number;
  errors: number;
  in_turnover: number;
  notices: number;
  to_be_corrected: number;
  warnings: number;
  items_total: DUItemTotals[];
}

export interface NormalizedDUTotals {
  data_unit_id: number;
  date: string;
  documents: number;
  errors: number;
  warnings: number;
  notices: number;
  to_be_corrected: number;
  corrected: number;
  in_turnover: number;
  errors_list: string[];
  warnings_list: string[];
  notices_list: string[];
  items_total: DUItemTotals[];
}

export interface DUTotalsRecalculation {
  company_id: string;
  data_unit_id: number;
  data_unit_item_id: number;
  date: string;
}
export interface DatevTileItem {
  option: string;
  asciiFilename: string;
  extfFilename: string;
  asciiFileId: number;
  extfFileId: number;
  generatedAt: Date;
  asciiErrorMessage?: string;
  extfErrorMessage?: string;
}
export interface NormalizedInvoiceErrors {
  warningsCount: number;
  errorsCount: number;
  noticesCount: number;
  errorCodes: string[];
  warningCodes: string[];
  noticeCodes: string[];
}

export interface NormalizedInvoiceErrorsStats {
  warningsCount: number;
  errorsCount: number;
  noticesCount: number;
  errorCodes: InvoiceDocumentError[];
  warningCodes: InvoiceDocumentError[];
  noticeCodes: InvoiceDocumentError[];
}

export interface Marketplace {
  id: number;
  name: string;
  country: Country;
}

export interface TodoItem {
  label?: string | JSX.Element;
  description?: string | JSX.Element;
  date: Date;
  action?: string | (() => void) | JSX.Element;
  btnLabel?: string;
  btnStyling?: BtnStyling;
  btnClassName?: string;
  id: string;
  disabled?: boolean;
  taskFor?: TaskForEnum;
  reportType?: SellerFilingReportType;
  hint?: JSX.Element;
  done?: boolean;
  hideDeadline?: boolean;
  subgroup?: TodoItem[];
  styling?: 'subgroup' | 'default';
  children?: JSX.Element;
  taskType?: WorkFlowTaskType;
}

export interface VatCalendarPoint {
  date: Date;
  countries: {
    name: string;
    period: ReportPeriod;
    report_sub_type: ReportSubType;
    type: string;
  }[];
}

export interface VatCalendarItem {
  items: VatCalendarPoint[];
  month: Date;
}

export interface DatevSettlement extends DatevFile {
  marketplace: Marketplace;
  calculated_amount: number;
  calculated_num_transactions: number;
  currency: { id: number; short_name: string; name: string };
  report_result_charts?: DatevReportResultChartItem[];
  error_message?: string;
}

export interface FilteredDefaultAccountsType {
  account_type: string;
  id: number;
  account_number: number;
}

export type ModalMode = (typeof MODAL_MODE)[keyof typeof MODAL_MODE];

export type CESTrigger = keyof typeof CES_CONFIG;

export type CESParams = Record<string, string>;

export interface BillingItem {
  id: number;
  icon: JSX.Element;
  description: string;
  title: string;
  button: JSX.Element;
}

export interface DataSourcePeriod {
  id: number;
  type: Source;
  period_from: string;
  period_to: string;
}
export interface IntegrationConnectionToDoType {
  id: string;
  label: JSX.Element | string | null;
  description: string;
  btnLabel?: string;
  onClick?: () => void;
  className?: string;
}

export type DatevRawFilesForSettlement = {
  amount: number;
  file: string;
  file_path: string;
  id: number;
  marketplace: {
    country: {
      id: number;
      is_eu: boolean;
      name: string;
      short_name: string;
    };
    id: number;
    is_amazon: boolean;
    name: string;
  };
  num_transactions: number;
  settlement_end_date: string;
  settlement_id: string;
  settlement_start_date: string;
  size: number;
};

export interface DatevReportResultChartItem {
  account_type_id: number;
  account_type_type: string;
  id: number;
  astt: string;
  amount: number;
}

export interface AsyncExportJob {
  id: number;
  status: 'processing' | 'ready' | 'failed';
  fromDate: string;
  toDate: string;
  errorMessage: string | null;
  createdAt: string;
  updatedAt: string;
  scope?: ProductListExportScope | null;
  issueField?: ProductIssueField | null;
  search?: string | null;
  fileName?: string | null;
}

export interface IncomingInvoiceItemsResponse {
  paging: IncomingInvoiceItemsPaging;
  data: IncomingInvoiceItem[];
}

export interface IncomingInvoiceItemsPaging {
  page: number;
  pageSize: number;
  totalPages: number;
  totalRows: number;
}

export interface IncomingInvoiceItem {
  id: number | null;
  invoiceIssuer: string | null;
  vatIdNumber: string | null;
  invoiceNumber: string | null;
  invoiceDate: string | null;
  serviceDate: string | null;
  invoiceItemType: string | null;
  serviceDescription: string | null;
  productInternalId: string | null;
  sku: string | null;
  asin: string | null;
  productDescription: string | null;
  weight: number | null;
  taricCode: string | null;
  countryOfOrigin: string | null;
  departureCountry: string | null;
  arrivalCountry: string | null;
  departurePostalCode: string | null;
  arrivalPostalCode: string | null;
  quantity: number | null;
  vatRate: number | null;
  vatAmount: number | null;
  brutto: number | null;
  netto: number | null;
  currency: string | null;
  vatTreatment: string | null;
  errors?: InvoiceDocumentError[];
}

export interface PatchIncomingInvoice {
  vat_id_number: string | null;
}

export type ProductListScope = 'current' | 'all_to_fix' | 'all';

export type ProductListExportScope = ProductListScope | 'current_complete';

export type ProductListSortKey =
  | 'sku'
  | 'asin'
  | 'price'
  | 'weight'
  | 'description'
  | 'country'
  | 'cn8'
  | 'period';

export type ProductListSortDir = 'asc' | 'desc';

export type ProductIssueField =
  | 'cn8'
  | 'purchase_price'
  | 'weight'
  | 'country_of_origin'
  | 'description';

export type ProductFieldStatus =
  | 'ok'
  | 'missing'
  | 'incorrect'
  | 'not_required';

export type ProductFieldReason =
  | 'price_missing'
  | 'price_not_positive'
  | 'proforma_price_zero'
  | 'regular_client'
  | 'digital'
  | 'weight_missing'
  | 'weight_zero'
  | 'description_missing'
  | 'flag_off'
  | 'country_missing'
  | 'cn8_missing'
  | 'cn8_not_in_cn';

export interface ProductField {
  value: string | null;
  status: ProductFieldStatus;
  reason: ProductFieldReason | null;
}

export interface ProductListItem {
  id: number;
  sku: string;
  asin: string | null;
  is_digital: boolean;
  period: string | null;
  updated_at: string | null;
  fields: {
    purchase_price: ProductField;
    weight: ProductField;
    description: ProductField;
    country_of_origin: ProductField;
    cn8: ProductField;
  };
}

export type ProductUpdateField =
  | 'purchase_price'
  | 'weight'
  | 'cn8'
  | 'country_of_origin'
  | 'description'
  | 'is_digital';

export type ProductUpdateReason =
  | 'price_missing'
  | 'price_not_positive'
  | 'price_not_numeric'
  | 'price_out_of_range'
  | 'weight_missing'
  | 'weight_zero'
  | 'weight_not_numeric'
  | 'cn8_missing'
  | 'cn8_invalid_format'
  | 'cn8_not_in_cn'
  | 'country_missing'
  | 'country_invalid'
  | 'description_missing'
  | 'field_read_only';

export interface ProductUpdateInput {
  updated_at: string | null;
  purchase_price?: string | null;
  weight?: string | null;
  is_digital?: boolean;
  cn8?: string | null;
  country_of_origin?: string | null;
  description?: string | null;
}

export interface ProductUpdateErrorResponse {
  errors: Partial<Record<ProductUpdateField, ProductUpdateReason>>;
}

export interface ProductUpdateConflictResponse {
  error: { code: 'product_changed'; message: string };
  item: ProductListItem;
}

export interface ProductList {
  client_type: 'regular' | 'intrastat';
  scope: ProductListScope;
  page: number;
  limit: number;
  total: number;
  pages: number;
  counts: {
    current: number;
    all_to_fix: number;
    all: number;
    current_complete: number;
  };
  issue_field: ProductIssueField | null;
  search: string | null;
  issue_counts: Record<
    ProductListScope,
    Partial<Record<ProductIssueField, number>>
  >;
  reporting_month: string | null;
  deadline_date: string | null;
  last_updated_at: string | null;
  items: ProductListItem[];
}
